/**
 * Smooth in-page scrolling for links marked [data-tr-scroll].
 *
 * Why JavaScript rather than CSS scroll-behavior: this theme does not always
 * scroll the document. At desktop widths html and body are overflow-y: hidden
 * and `.page-wrapper` is the scroll container, so `scroll-behavior` on the root
 * governs nothing. scrollIntoView walks up to whichever element is actually
 * scrollable and moves that one.
 *
 * The href stays a real fragment, so with JavaScript unavailable the link still
 * jumps to the target natively.
 */
(() => {
  const SELECTOR = 'a[data-tr-scroll][href^="#"]';

  const onClick = (event) => {
    const link = event.target.closest(SELECTOR);
    if (!link) return;

    const id = link.getAttribute('href').slice(1);
    if (!id) return;

    const target = document.getElementById(id);
    if (!target) return; // let the browser handle a missing target

    event.preventDefault();

    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });

    // Move focus so keyboard and screen-reader users follow the jump too.
    // The anchor is not focusable by default, so make it focusable for this
    // one move and release it again on blur.
    if (!target.hasAttribute('tabindex')) {
      target.setAttribute('tabindex', '-1');
      target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
    }
    target.focus({ preventScroll: true });

    // Keep the URL shareable without adding a history entry per click.
    if (window.history?.replaceState) {
      window.history.replaceState(null, '', `#${id}`);
    }
  };

  // One delegated listener for the whole document, added once even if several
  // sections load this file.
  if (!window.__trScrollLinkBound) {
    window.__trScrollLinkBound = true;
    document.addEventListener('click', onClick);
  }
})();
